import {
    ChatContextTypeEnum,
    Project,
    Task,
    Location,
    ChatSearchTopic
} from '../../../../gql/graphql';

export interface LocationChatModalData {
    open: boolean;
}

export enum SearchLevel {
    LEVEL1 = 1, // Project, WorkPackage, Epic, Machine
    LEVEL2 = 2, // Project - Location
    LEVEL3 = 3, // Project - Location - Task
    LEVEL4 = 4 // Project - Location - Task - Raport, Graph or other...
}

export interface ChatTopic extends ChatSearchTopic {
    //Name: string;
    MetaDataSlot1?: string;
    MetaDataSlot2?: string;
    MetaDataSlot3?: string;
    //ChatContextType: ChatContextTypeEnum;
    //EntityId: number;
    Fixed?: boolean;
    Level: SearchLevel;
    Item?: Task | Project | Location;
}

export enum ConversationModalSize {
    BIG = 1,
    MID = 2,
    SMALL = 3
}

export enum ConversationModalPosition {
    LEFT = 1,
    RIGHT = 2
}
